import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "w-full flex items-center"
};
const _hoisted_2 = {
  class: "flex flex-col mr-2 grow"
};
const _hoisted_3 = {
  class: "text-lg"
};
import Progress from "@/modules/vue/components/Progress.vue";
import Gate from "@/modules/action-points/components/Gate.vue";
import { GateTypeEnum } from "@/modules/action-points/enums";
import { app } from "@/di";
import { RegionScoutingEvaluator } from "@/modules/youth/services/evaluators/RegionScoutingEvaluator";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
export default /*#__PURE__*/_defineComponent({
  __name: 'Region',
  props: {
    region: null
  },
  emits: ['updated'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const cost = computed(() => app.get(ConfigRepository).get('scouting.actionPointsCosts.region'));
    const onScoutingAction = async commit => {
      await app.get(RegionScoutingEvaluator).evaluate(props.region);
      await commit();
      emit('updated');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(__props.region.name), 1), _createVNode(Progress, {
        value: __props.region.newPlayerProgress
      }, null, 8, ["value"])]), _createVNode(Gate, {
        type: _unref(GateTypeEnum).SCOUTING,
        value: _unref(cost),
        "no-confirm": "",
        onAction: onScoutingAction
      }, null, 8, ["type", "value"])]);
    };
  }
});